import { Component } from '@angular/core'
import { PageComponent } from '@account/Components/ui/Page/Page.Component'

@Component({
	selector: 'page-not-found',
	template: ` <account-page> Not found</account-page> `,
	imports: [PageComponent],
})
export class PageNotFoundComponent {}
